import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('batteryNameField');

    return {
        BATTERY_NAME_FIELD_LABEL: t('batteryNameFieldLabel')
    };
};

export default useTranslation;
